import { I as r } from "../../index.esm-BgWtdyFo.js";
import { F as o, a as n } from "../../index.esm-CPPzQn_Y.js";
import { F as c } from "../../index.esm-DXyVSsY7.js";
const l = [
  "Anesthesiologist",
  "Anesthesiology Fellow",
  "Certified Registered Nurse Anesthetist",
  "Registered Respiratory Therapist",
  "Anesthesiologist Assistant",
  "Cardiologist",
  "Cardiology Fellow",
  "Cardiology Physician Assistant",
  "Cardiac Scientist",
  "Cardiovascular Technologist",
  "Intensivist",
  "Neonatologist",
  "Critical Care Medicine Physician Assistant",
  "Critical Care Nurse Practitioner",
  "Critical Care Registered Nurse",
  "Critical Care Respiratory Therapist",
  "Dentist",
  "Dental Hygienist",
  "Denturist",
  "Dental Assistant",
  "Dental Technician",
  "Dermatologist",
  "Dermatology Physician Assistant",
  "Dietitian",
  "Emergency physician",
  "Emergency Physician Assistant",
  "Emergency Nurse Practitioner",
  "Flight Nurse",
  "Certified Emergency Nursing Assistant",
  "Certified Emergency Registered Nurse",
  "Certified Emergency Registered Respiratory Therapist",
  "Emergency Medical Technician - Critical Care Paramedic",
  "Emergency Medical Technician - Paramedic",
  "Emergency Medical Technician - Intermediate 99",
  "Emergency Medical Technician - Intermediate 85",
  "Emergency Medical Technician - Basic",
  "Endocrinologist",
  "Endocrinology Physician Assistant",
  "Gastroenterologist",
  "Gastroenterology Physician Assistant",
  "Genetic Counselor/Counsellor",
  "Geriatrician",
  "Geriatric Medicine Physician Assistant",
  "Gerontological Nurse Practitioner",
  "Occupational Therapist",
  "Haematologist",
  "Haematology Physician Assistant",
  "Medical Laboratory Technician",
  "Phlebotomist",
  "Nephrologist",
  "Nephrology Physician Assistant",
  "Dialysis Technician",
  "Neurologist",
  "Neurology Physician assistant",
  "Speech Language Pathologist",
  "Audiologist",
  "Neuropsychologist",
  "Neurodiagnostic Technologist",
  "Oncologist",
  "Oncology Physician Assistant",
  "Radiation Therapist",
  "Ophthalmologist",
  "Eye Surgery",
  "Optometrist",
  "Occupational Therapist- Low Vision Rehab",
  "Otolaryngologist (Ear, Nose and Throat physician)",
  "Otorhinolaryngology Physician assistant",
  "Healthcare Chaplain",
  "Pathologist",
  "Pulmonologist",
  "Pulmonology/Respirology Physician Assistant",
  "General practitioner",
  "Primary care physician",
  "Internist",
  "Physician assistant",
  "Family nurse practitioner",
  "Pharmacist",
  "Community Health practitioner",
  "Pediatrician",
  "Pediatric Physician Assistant",
  "Neonatal Nurse Practitioner",
  "Pediatric Nurse Practitioner",
  "Occupational Therapist- Neonatal/ Pediatric",
  "Pediatric Nurse",
  "Pediatric Respiratory Therapist",
  "Pharmacy technician",
  "Podiatric Surgeon",
  "Doctor of Podiatric Medicine",
  "Podiatrist",
  "Chiropodist",
  "Psychiatrist",
  "Psychiatry Physician Assistant",
  "Psychologist",
  "Psychiatric Nurse Practitioner",
  "Mental Health Nurse Practitioner",
  "Social Worker",
  "Mental Health Counselor",
  "Medical Officer of Health",
  "Environmental Health Officer",
  "Epidemiologist",
  "Public Health Nurse",
  "Orthopedic Physician",
  "Orthopaedic Physician's Assistant",
  "Sport Psychologist",
  "Physical Therapist",
  "Physical Therapy Assistant",
  "Occupational Therapy Assistant",
  "Orthopaedic Technologist or Prosthetist & Orthotist",
  "Chiropractor",
  "Biokineticist",
  "Athletic Trainer",
  "Yoga Instructor",
  "Massage Therapist",
  "Radiologist",
  "Radiology Physician Assistant",
  "Radiotherapist",
  "Radiographer",
  "CT Radiographer",
  "Interventional Radiographer",
  "Mammographer",
  "Neuroradiographer",
  "Medical Dosimetry Technologist",
  "Radiologist Practitioner Assistant",
  "Reporting Radiographer",
  "Sonographer",
  "Obstetrician",
  "Gynaecologist",
  "OB/GYN Physician Assistant",
  "Women's Health Nurse Practitioner",
  "Nurse-Midwife",
  "Midwife",
  "Lactation consultant",
  "General Doctor",
  "Bariatric Surgeon",
  "Cardiothoracic surgeon",
  "Cardiac Surgeon",
  "Hepatic Biliary Pancreatic Surgeon",
  "Neurosurgeon",
  "Surgery Physician Assistant",
  "Urologist",
  "Urology Physician Assistant"
], h = [
  "Biological researcher",
  "Biochemical researcher",
  "Drug discovery researcher"
], a = "Health Worker", t = "Researcher", p = e(a), P = e(t), s = l.map((i) => ({
  label: i,
  value: i
}));
s.push({ label: "Other", value: "other" });
s.unshift({ label: "None", value: "" });
const g = h.map((i) => ({
  label: i,
  value: e(i)
}));
g.unshift({ label: "None", value: "" });
const m = [
  {
    label: "Health Seeker",
    text: "Individuals without medical training seeking health information or services for personal needs and education.",
    value: "general_public",
    icon: r
  },
  {
    label: "Medical Student",
    text: "Individuals enrolled in medical school, training to become doctors. In various stages of learning clinical and theoretical aspects of medicine.",
    value: "medical_student",
    icon: o
  },
  {
    label: a,
    text: "Professionals providing health services, including doctors, nurses, therapists, technicians, and support staff across medical fields.",
    value: e(a),
    icon: c
  },
  {
    label: t,
    text: "Researchers conducting research in the field of medicine, including biomedical research, clinical research, and health policy research.",
    value: e(t),
    icon: n
  }
];
function e(i) {
  return i.replace(/\s+/g, "_").toLowerCase();
}
export {
  s as HEALTH_WORKER_OPTIONS,
  p as HEALTH_WORKER_ROLE_VALUE,
  g as RESEARCHER_OPTIONS,
  P as RESEARCHER_ROLE_VALUE,
  m as ROLES
};
